// extracted by mini-css-extract-plugin
export default {"card":"card__UoOkIU","table":"table__WO0EWP","select":"select__fQ4tYl","cssExpandedRow":"cssExpandedRow__SqX8cg","addRow":"addRow__PDQ1GX","nameInput":"nameInput__V1myTU"};